import { withConditional } from './components/conditional-hoc';
import Conditional from './components/conditional';

export { withConditional };
export default Conditional;
